import {Telegraf} from "telegraf";
import { UserFromGetMe } from "telegraf/typings/core/types/typegram";
import {createPromise, PromiseObject} from "../services/utils/promise";
type TelegramRequestParams = unknown;

export interface MessageQueueData {
  id: string,
  action: string;
  botInfo: BotInfo;
  data: TelegramRequestParams;
  promiseHandler: PromiseObject<any>
}

export interface BotInfo {
  name: string,
  rateLimit: number,
  intervalTime: number,
}

export class KoniBot {
  public isLaunched = false;
  public readonly bot : Telegraf;
  private messageQueue =  {} as Record<string, MessageQueueData>;
  private isRunningSendMessage = false;
  private miniapp: string;
  private botModel: any;

  get botInfo(): UserFromGetMe {
    return this.bot.botInfo;
  }

  constructor(public readonly token: string, _miniapp?: string) {
    this.bot = new Telegraf(token);
    this.listenSigterm();
    this.miniapp = _miniapp || '';
  }

  getBotModel() {
    return this.botModel;
  }

  setBotModel(botModel: any) {
    this.botModel = botModel;
  }

  public async launch() {
    if (this.isLaunched) {
      return;
    }

    // Start bot
    await this.bot.launch();
  }

  public async stop(reason?: string) {
    this.bot.stop(reason);
  }

  public listenSigterm() {
    // Enable graceful stop
    process.once('SIGINT', () => this.bot.stop('SIGINT'))
    process.once('SIGTERM', () => this.bot.stop('SIGTERM'))
  }

  public getMiniApp() {
    return this.miniapp;
  }

  async addMessageQueue<T>(action: string, botInfo: BotInfo, data: unknown) {
    const promiseHandler = createPromise<any>();
    const {chat_id} = data as { chat_id: string };
    // Random unique id
    const id = `${chat_id}-${new Date().getTime()}`;
    const actionObj: MessageQueueData = {
      id: id,
      action,
      data,
      botInfo,
      promiseHandler,
    };

    this.messageQueue[actionObj.id] = actionObj;
    this.process(botInfo.rateLimit, botInfo.intervalTime);

    return promiseHandler.promise;
  }

  process(rateLimit: number, intervalTime: number) {
    if (this.isRunningSendMessage) {
      return;
    }

    const processInterval = setInterval(() => {
      if (Object.keys(this.messageQueue).length === 0) {
        clearInterval(processInterval);
        this.isRunningSendMessage = false;
        return;
      }

      // Get TELEGRAM_RATE_LIMIT messages and send
      // Get config in metadata
      const actions = Object.values(this.messageQueue).slice(0, rateLimit);

      actions.forEach(({id, action, data, promiseHandler}) => {
        this.runSendMessage(action, data)
          .then(promiseHandler.resolve)
          .catch(promiseHandler.reject);

        delete this.messageQueue[id];
      });
    }, intervalTime);

    this.isRunningSendMessage = true;
  }
  async runSendMessage<T>(action: string, data: any){
    const {chat_id, photo, ...result} = data as {chat_id: string, photo: string, caption: string};
    let actionSend = null;
    switch (action) {
      case 'sendPhoto':
        actionSend = this.bot.telegram.sendPhoto(chat_id, photo, result);
        break;
    }

    // Send action
    try {
      await actionSend;
    }catch (e) {
      strapi.log.error(e);
    }
  }
}
